import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject;
import { css } from "styled-components";
export var CSS_BTN_PADDING = css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding-top: 0;\n  padding-bottom: 0;\n  padding-right: ", ";\n  padding-left: ", ";\n"])), p => getPaddingRight(p), p => getPaddingLeft(p));

/* =================== PRIVATE FUNCTION =================== */
var padding = {
  large: 16,
  normal: 12,
  small: 8
};
var getPaddingLeft = props => {
  var {
    size = 'normal',
    content
  } = props;
  if (content === 'only-icon') {
    return size === 'small' ? '3px' : '4px';
  }

  //    如果同时有图标有文字，左侧 padding 减少 2px
  if (content === 'icon-text') {
    return padding[size] - 2 + "px";
  } else {
    return padding[size] + "px";
  }
};
var getPaddingRight = props => {
  var {
    size = 'normal',
    content
  } = props;
  if (content === 'only-icon') {
    return size === 'small' ? '3px' : '4px';
  }
  return padding[size] + "px";
};
//# sourceMappingURL=button.js.map